import { autorun, makeAutoObservable } from "mobx"

import WorkbookReportStore from "./report.store"

const PENDING_WORKBOOK_REPORTS_KEY = "PENDING_WORKBOOK_REPORTS"

export default class WorkbookReportsStore {
  reports: Map<string, WorkbookReportStore>

  taskToNotifySet: Set<string>

  constructor() {
    this.reports = new Map()

    this.taskToNotifySet = new Set(this.restoreTaskNotifications())

    makeAutoObservable(this)

    autorun(() =>
      this.storeTaskNotifications([...this.taskToNotifySet.values()])
    )
  }

  get getById() {
    return (id: string) => {
      const report = this.reports.get(id)
      if (report == null) this.reports.set(id, new WorkbookReportStore(id))
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return this.reports.get(id)!
    }
  }

  addTaskNotification = (reportId: string) => {
    this.taskToNotifySet.add(reportId)
  }

  removeTaskNotification = (reportId: string) => {
    this.taskToNotifySet.delete(reportId)
  }

  storeTaskNotifications = (taskIds: string[]) => {
    localStorage.setItem(PENDING_WORKBOOK_REPORTS_KEY, JSON.stringify(taskIds))
  }

  restoreTaskNotifications = () => {
    try {
      const dataStr = localStorage.getItem(PENDING_WORKBOOK_REPORTS_KEY)

      const data = dataStr ? JSON.parse(dataStr) : []

      if (typeof data !== "object" || !Array.isArray(data))
        throw new Error("Tasks parsing failed")

      return data
    } catch (error) {
      console.error(error)
    }
    return []
  }

  get isNotified() {
    return (reportId: string) => this.taskToNotifySet.has(reportId)
  }

  get taskToNotifyList() {
    return [...this.taskToNotifySet.values()]
  }

  get totalReportsToNotify() {
    return this.taskToNotifyList.length
  }

  get totalCompletedReports() {
    return this.taskToNotifyList.reduce((acc, id) => {
      return acc + (this.getById(id).status !== "in-progress" ? 1 : 0)
    }, 0)
  }
}
